
import {createBrowserRouter,RouterProvider,BrowserRouter,Routes,Route} from 'react-router-dom';
import { Programs } from "./Components/Programs";
import { Map } from "./Components/Map";
import { Map as LimsMap } from "./Components/Lims-Map";
import ResumePage from "./Components/Resume";

function App() {
  return <BrowserRouter >
    <Routes>
        <Route path="/" element={<ResumePage></ResumePage>}></Route>
        <Route path="/area" element={<Programs></Programs>}></Route>
        <Route path="/map" element={<Map></Map>}></Route>
        <Route path="/lims-sites" element={<LimsMap></LimsMap>}></Route>
    </Routes>
  
  </BrowserRouter>
}

export default App;
